import { useState, useEffect } from 'react';
import { useApi, fetchApiRef } from '@backstage/core-plugin-api';
import { fetchRepoBranches } from '../services/githubService';

type GithubBranch = { name: string };

export function useGithubBranches(
  ownerRepo: string | undefined,
): { branches: GithubBranch[]; loading: boolean; error: string | undefined } {
  const fetchApi = useApi(fetchApiRef);
  const [branches, setBranches] = useState<GithubBranch[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (!ownerRepo) {
      setBranches([]);
      return;
    }

    const [owner, repo] = ownerRepo.split('/');
    if (!owner || !repo) {
      setBranches([]);
      return;
    }

    const load = async () => {
      setLoading(true);
      setError(undefined);
      try {
        setBranches(await fetchRepoBranches(fetchApi, owner, repo));
      } catch (e: any) {
        setError(e.message);
        setBranches([]);
      }
      setLoading(false);
    };

    load();
  }, [ownerRepo, fetchApi]);

  return { branches, loading, error };
}
